import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line no-unused-vars
const QRCode = ({ fill = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_10786_12316"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <path
        d="M17.8578 0.619385H0.57782V17.8994H17.8578V0.619385Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_10786_12316)">
      <path
        d="M9.9378 15.7393V14.2993H11.3778V15.7393H9.9378ZM8.4978 14.2993V10.6993H9.9378V14.2993H8.4978ZM14.2578 12.1393V9.25929H15.6978V12.1393H14.2578ZM12.8178 9.25929V7.81929H14.2578V9.25929H12.8178ZM4.17779 10.6993V9.25929H5.61779V10.6993H4.17779ZM2.73779 9.25929V7.81929H4.17779V9.25929H2.73779ZM9.2178 4.2193V2.7793H10.6578V4.2193H9.2178ZM3.81779 6.0193H5.97779V3.8593H3.81779V6.0193ZM2.73779 7.0993V2.7793H7.05779V7.0993H2.73779ZM3.81779 14.6593H5.97779V12.4993H3.81779V14.6593ZM2.73779 15.7393V11.4193H7.05779V15.7393H2.73779ZM12.4578 6.0193H14.6178V3.8593H12.4578V6.0193ZM11.3778 7.0993V2.7793H15.6978V7.0993H11.3778ZM12.8178 15.7393V13.5793H11.3778V12.1393H14.2578V14.2993H15.6978V15.7393H12.8178ZM9.9378 10.6993V9.25929H12.8178V10.6993H9.9378ZM7.05779 10.6993V9.25929H5.61779V7.81929H9.9378V9.25929H8.4978V10.6993H7.05779ZM7.7778 7.0993V4.2193H9.2178V5.6593H10.6578V7.0993H7.7778ZM4.35779 5.4793V4.3993H5.43779V5.4793H4.35779ZM4.35779 14.1193V13.0393H5.43779V14.1193H4.35779ZM12.9978 5.4793V4.3993H14.0778V5.4793H12.9978Z"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
    </g>
  </svg>
);

QRCode.propTypes = {
  fill: PropTypes.string,
};

export default QRCode;
